import { AdvancedSearchExecuteData, AdvancedSearchSaveModel, AdvArticleResult } from "@medapro-types/AdvancedSearch/AdvancedSearch";
import api from "./api";
import endpoints from "./endpoints";
import { getHexFromAhex } from "@util/color";

export default {
  getSearchTypes: async function (language: string) {
    const response = await api.get(endpoints.advancedSearch.getSearchTypes, { params: { language } });
    return response.data;
  },
  getAll: async function () {
    const response = await api.get(endpoints.advancedSearch.getAll);
    return response.data;
  },
  get: async function (advancedSearchId: string) {
    const response = await api.get(endpoints.advancedSearch.get, { params: { advancedSearchId } });
    return response.data;
  },
  save: async function (advancedSearch: AdvancedSearchSaveModel) {
    const postdata = Object.assign({}, advancedSearch);
    postdata.searchJson = JSON.stringify(advancedSearch.searchJson);
    const response = await api.post(endpoints.advancedSearch.save, postdata);
    return response.data;
  },
  execute: async function (advancedSearchData: AdvancedSearchExecuteData): Promise<AdvArticleResult[]> {
    const response = await api.get(endpoints.advancedSearch.execute, { params: advancedSearchData });
    const data: AdvArticleResult[] = response.data;
    for (const entry of data) {
      entry.stateColor = `#${getHexFromAhex(entry.stateColor)}`;
    }
    return data;
  },
  canDelete: async function (advancedSearchId: string, language: string) {
    const response = await api.get(endpoints.advancedSearch.canDelete, { params: { advancedSearchId, language } });
    return response.data;
  },
  delete: async function (advancedSearchId: string) {
    const response = await api.post(endpoints.advancedSearch.delete, {}, { params: { advancedSearchId } });
    return response.data;
  },
  exportToCsv: async function (advancedSearchId: string, language: string) {
    const response = await api.get(endpoints.advancedSearch.exportCsv, { params: { advancedSearchId, language } });
    return response.data;
  },
  downloadCsv: async function (token: string, searchName: string) {
    const response = await api.get(endpoints.advancedSearch.downloadCsv, { params: { token, searchName } });
    return response.data;
  }
};
